'use client';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { globalSearchApi } from '@/services/api/globalSearch.api';
import { SearchQueryParams } from '@/types/search.types';

export const GLOBAL_SEARCH_QUERY_KEYS = {
  all: ['globalSearch'] as const,
  search: (params: SearchQueryParams) =>
    [...GLOBAL_SEARCH_QUERY_KEYS.all, 'query', params] as const,
};

export const useGlobalSearch = (params: SearchQueryParams) => {
  return useQuery({
    queryKey: GLOBAL_SEARCH_QUERY_KEYS.search(params),
    queryFn: () => globalSearchApi.search(params),
    enabled: !!params.q && params.q.length > 0,
    staleTime: 30_000,
    gcTime: 5 * 60_000,
  });
};

export const useGlobalSearchInfinite = (params: SearchQueryParams) => {
  return useInfiniteQuery({
    queryKey: GLOBAL_SEARCH_QUERY_KEYS.search(params),
    queryFn: ({ pageParam = 1 }) =>
      globalSearchApi.search({ ...params, page: pageParam as number }),
    initialPageParam: 1,
    enabled: !!params.q && params.q.length > 0,
    staleTime: 30_000,
    gcTime: 5 * 60_000,
    getNextPageParam: (lastPage: any, allPages: any[]) => {
      if (!lastPage || !allPages) return undefined;
      return lastPage.hasMore ? allPages.length + 1 : undefined;
    },
  });
};
